enum notificationTestIds {
	notificationContent = 'notification-content',
	ackCheck = 'ack-check',
}

export default notificationTestIds;
